require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./police-use-of-force-and-people-with-mental-illness.json") })
        }
      }, "path---police-use-of-force-and-people-with-mental-illness");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---police-use-of-force-and-people-with-mental-illness!./.cache/json/police-use-of-force-and-people-with-mental-illness.json
// module id = 953
// module chunks = 231608221292675